const IntroSection = () => {
    return (
        <section id="intro">
            <div className="lines">
                <div className="line line1"></div>
                <div className="line line2"></div>
                <div className="line line3"></div>
                <div className="line line4"></div>
            </div>
            <div className="content">
                <div className="title">
                    <h2>Polyglow, <br />votre  <span>passeport</span>  pour  <span>rayonner</span>  à l'international</h2>
                </div>
                <div className="text">
                    <p>Conçue pour les professionnels et les étudiants, cette application aide à maîtriser rapidement les compétences linguistiques essentielles pour réussir dans un contexte international. Grâce à une méthode d'apprentissage ludique et interactive, elle permet de progresser tout en s'amusant et de rendre à la fois efficace et agréable l’acquisition du vocabulaire et des expressions spécifiques au monde des affaires.</p>
                </div>
            </div>
        </section>
    );
};


export default IntroSection;